import React, { useState, useEffect } from "react"
import Button from "react-bootstrap/lib/Button"

import Spinner from "../../ui-components/Spinner"
import SingleFieldFormWithValidation from "../../ui-components/SingleFieldFormWithValidation"
import LocationAPI from "../../apis/LocationAPI"

import style from "./index.module.sass"
import {
  intercomSendData,
  intercomTrackEvent,
} from "../../utils/Intercom/intercomHelper"

// ----------------------------------------------------------------------------

const steps = { leaveMail: 1, loading: 2, success: 3, error: 4 }
const success_message = I18n.t("react.venues.no_result.success_message")
const error_message = I18n.t("react.venues.no_result.error_message")

function sendUncoveredAddressToIntercom(city) {
  if (!window.Intercom || typeof window.Intercom !== "function") {
    return
  }

  try {
    intercomTrackEvent("searched-uncovered-zone", {
      "Created at": new Date(),
      "Not covered zone": city,
    })

    intercomSendData({
      "Last not covered zone": city,
    })
  } catch (error) {
    console.log(error)
  }
}

export default function ZoneNotCovered(props) {
  // -------------------------------------
  // Props destructuring
  // -------------------------------------

  const { location } = props

  // -------------------------------------
  // Hooks (e.g. useState, useMemo ...)
  // -------------------------------------

  const [step, setStep] = useState(steps.leaveMail)
  const [email, setEmail] = useState("")

  // -------------------------------------
  // Effects
  // -------------------------------------

  useEffect(() => {
    sendUncoveredAddressToIntercom(location.city)
  }, [])

  // -------------------------------------
  // Component functions
  // -------------------------------------

  function onSend() {
    setStep(steps.loading)

    let apiData = { ...location, email: email }
    LocationAPI.SendLocationSubscription(apiData)
      .then((res) => {
        setStep(steps.success)
      })
      .catch((err) => {
        setStep(steps.error)
      })
  }

  function onRetry() {
    setStep(steps.leaveMail)
  }

  // -------------------------------------
  // Component local variables
  // -------------------------------------

  // -------------------------------------

  return (
    <div className={props.className}>
      <div className="col-sm-8 col-xs-12 col-sm-offset-1">
        <div className="no-delivery-box">
          {step === steps.leaveMail && (
            <div>
              <div className={`${style.standardContainer}`}>
                <div
                  className={`${style.standardContainer} p-5 ${style.minHeightContainer}`}
                >
                  <h1>😔</h1>
                  <h2 className="featurette-heading">
                    {I18n.t("react.venues.no_result.page_title")}
                  </h2>
                  <p className={`lead ${style.title}`}>
                    {I18n.t("react.venues.no_result.page_subtitle")}
                  </p>
                  <p className={`lead ${style.titleLight}`}>
                    {I18n.t("react.venues.no_result.page_description")}
                  </p>
                </div>
                <SingleFieldFormWithValidation
                  type="email"
                  value={email}
                  setValue={setEmail}
                  placeholder={I18n.t(
                    "react.venues.no_result.email_placeholder"
                  )}
                  buttonStyle="primary"
                  buttonLabel={I18n.t("react.venues.no_result.button_notify")}
                  onSubmit={onSend}
                />
              </div>
            </div>
          )}
          {step === steps.loading && <Spinner />}
          {(step === steps.success || step === steps.error) && (
            <div>
              <div className={style.standardContainer}>
                <h4
                  className={`${style.standardContainer} p-5`}
                  style={{ minHeight: 330 }}
                >
                  {step === steps.success ? success_message : error_message}
                </h4>
                {step === steps.error && (
                  <Button bsStyle="primary" bsSize="large" onClick={onRetry}>
                    {I18n.t("react.venues.no_result.retry")}
                  </Button>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

// ----------------------------------------------------------------------------
